<template>
  <div :class="['loading-dots', loadingDotsClasses]">
    <div v-for="dot in 3" :key="dot" :class="['loading-dot', `dot-${dot}`]"></div>
  </div>
</template>

<script>
  export default {
    props: {
      loadingDotsClasses: String,
    },

    name: 'LoadingDots',
  }
</script>